module.exports = __webpack_public_path__ + "static/cr-average-8a2ef0d83e4df1cb237be241bbb7fb8b.png";